var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Bed",
    "data-name": "Controls/icon/Bed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2902",
    "data-name": "Group 2902"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2322",
    "data-name": "Rectangle 2322",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M44.923,24.149a1.076,1.076,0,0,0,.041-.2V19.331a1.221,1.221,0,0,0-.63-1.07c-3.777-2.077-8.665-3.1-14.937-3.123h-.256c-6.273.023-11.16,1.046-14.937,3.123a1.221,1.221,0,0,0-.63,1.07v4.615a.786.786,0,0,0,.041.2c-1.444.631-2.346,1.463-2.346,2.559V41.919a1.212,1.212,0,0,0,1.208,1.218h7.392a1.213,1.213,0,0,0,1.208-1.218V38.691H37.462v3.227a1.212,1.212,0,0,0,1.208,1.218h7.392a1.212,1.212,0,0,0,1.208-1.218V26.708C47.269,25.612,46.368,24.78,44.923,24.149ZM15.989,20.072c3.359-1.671,7.714-2.488,13.279-2.5,5.566.01,9.921.828,13.28,2.5v3.314c-.149-.035-.3-.071-.449-.105-4.093-2.692-8-3.592-12.176-1.027H28.614c-4.172-2.563-8.079-1.663-12.169,1.026-.155.034-.305.07-.456.106ZM44.854,40.7H39.877V37.473a1.213,1.213,0,0,0-1.208-1.218h-18.8a1.212,1.212,0,0,0-1.208,1.218V40.7H13.684V26.817c.947-1.121,8.283-2.128,15.584-2.128S43.907,25.7,44.854,26.817Z",
    transform: "translate(-10.269 -8.137)",
    fill: "#75787b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.6f4a2e3ce3c2e0471662f50ec2948242.svg";
export { ForwardRef as ReactComponent };